export const FETCH_VIDEOS = '/video';
export const ADD_VIDEOS = '/video';
export const FETCH_VIDEO_FOR_ADMIN = '/video/admin';
export const ADD_VIDEOS_FILE = '/video/file';
export const GET_SINGLE_VIDEO = 'singlevideo';